import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TFormTypeEvaluationType {
  id: number;
  formTypeCode: string;
  evaluationTypeId: number;
}

export interface IFormTypeEvaluationType extends TFormTypeEvaluationType {}

const FormTypeEvaluationType = Model(
  (model: TFormTypeEvaluationType): IFormTypeEvaluationType => {
    const _formTypeEvaluationType: TFormTypeEvaluationType = Object.assign(
      {},
      model
    );

    let create = (
      formTypeEvaluationType: IFormTypeEvaluationType
    ): IFormTypeEvaluationType => {
      let obj = ValidatableObject(formTypeEvaluationType);
      return obj;
    };

    let formTypeEvaluationType = {
      get id() {
        return _formTypeEvaluationType.id;
      },
      set id(value) {
        _formTypeEvaluationType.id = value;
      },
      get formTypeCode() {
        return _formTypeEvaluationType.formTypeCode;
      },
      set formTypeCode(value) {
        _formTypeEvaluationType.formTypeCode = value;
      },
      get evaluationTypeId() {
        return _formTypeEvaluationType.evaluationTypeId;
      },
      set evaluationTypeId(value) {
        _formTypeEvaluationType.evaluationTypeId = value;
      }
    };

    return create(formTypeEvaluationType);
  }
);

export default FormTypeEvaluationType;
